import { Component, OnInit, Inject } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ServicepoolService } from '../services/servicepool.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';



@Component({
  selector: 'app-detailcommande',
  templateUrl: './detailcommande.component.html',
  styleUrls: ['./detailcommande.component.css']
})
export class DetailcommandeComponent implements OnInit {

	detailsCommande = [] ;

	retourClientWS  : ReponseWebService ;

	productionId : any ;

	theProduction : any ;
	infosProd : any ;
	autresinfos : any ;
	garanties : any ;
	montantdevis : any ;
	prenom : any ;
	nom : any ;

	partners = [] ;
	partner : any ;
	current = 0 ;

	constructor( private configServer: ServicepoolService, public dialogRef: MatDialogRef<DetailcommandeComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any ) {
		this.productionId = data.idprod ;
		console.log("The Production ID IS") ;
		console.log(this.productionId) ;
	}

	ngOnInit(): void {
		this.getDetailProdLine(this.productionId) ;
	}

	getDetailProdLine(idprod){
		this.configServer.getDetailProdLine(idprod).then( (retourbi) => {

		    this.retourClientWS = retourbi ;
		    var statutrec = this.retourClientWS.statutreq ;

		    if(statutrec==1){
		    	this.theProduction = this.retourClientWS.data[0] ;
				this.infosProd = JSON.parse(this.theProduction.infos) ;
				this.autresinfos = JSON.parse(this.theProduction.autresinfos) ;
				this.garanties = JSON.parse(this.theProduction.garanties) ;
				this.montantdevis = this.theProduction.montantdevis ;
				this.prenom = this.theProduction.prenom ;
				this.nom = this.theProduction.nom ;
			    console.log(this.theProduction.infos) ;  
		    }
		    else
		      console.log("Failed") ;
		}) ;    
	}


}
